/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNumbers = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 18v2h-8v-2zM8.001 18v2H6v-2zM12 18v2h-2v-2zm-8 0v2H2v-2zm17.999-7v2H10v-2zM8 11v2H6v-2zm-4 0v2H2v-2zm18-7v2H6V4zM4 4v2H2V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNumbers as Numbers };
